export const PurchaseErrors: Record<string, string> = {
  'Unable to authorize a purchase without items':
    'Não é possível autorizar uma compra sem itens.',
  'Unable to cancel purchase with generated financial.':
    'Não é possível cancelar uma compra que já tenha sido gerado financeiro!',
  'Unable to cancel purchase. There is a return to vendor record':
    'Não é possível retornar uma compra que já tenha sido feita a devolução.',
  'The CNPJ informed is imcompatible with the registered company':
    'O CNPJ informado é incompatível com o da empresa cadastrada',
  'To carry out the operation it is necessary to have stock available. Check the stock':
    'Para realizar a operação é necessário ter estoque disponível. Verifique o estoque.',
  'Unable to authorize a purchase that is not open':
    'Não é possível autorizar uma compra que não está aberta',
  'Purchase exists for this supplier with this document number.':
    'Existe compra para este fornecedor com este número de documento.',
};
